import _ from 'lodash'

import { MydAPI } from '_services/default'


export const deserializeUserData = data => {
  const {id, attributes} = data
  return {
    id,
    ...attributes,
  }
}

export const fetchTeachersByTreeNode = _.memoize((treenodeId) => {
  return new Promise((resolve, reject) => {

    MydAPI.get(`/treenode/${treenodeId}/users/teachers?page[size]=0`).then(response => {

      if (response.status === 200) {
        let retData = response.data.data,
            retUser = _.map(retData, deserializeUserData)

        resolve(retUser)
      } else {
        resolve({})
      }

    }).catch(err => {
      reject(err)
    })
  })
})

export const fetchUser = _.memoize((userId) => {
  return new Promise((resolve, reject) => {


    MydAPI.get(`/users/${userId}`).then(response => {

      if (response.status === 200) {
        let retData = response.data.data,
            retUser = deserializeUserData(retData)

        resolve(retUser)
      } else {
        resolve({})
      }

    }).catch(err => {
      reject(`Error loading user id: ${userId}`)
    })
  })
})

export const fetchUserByUrl = _.memoize((url) => {
  return new Promise((resolve, reject) => {

    MydAPI.get(`/users/url/${url}`).then(response => {

      if (response.status === 200) {
        let retData = _.get(response.data, 'data', false),
            retUser = {}

        if (retData !== false) {
          retUser = deserializeUserData(retData)
        }

        resolve(retUser)
      } else {
        resolve({})
      }

    }).catch(err => {
      reject(`Error loading user: ${url}`)
    })
  })
})
